import React from 'react';

/**
 * Small "PRO" lock badge rendered next to gated nav items for non-Pro users.
 * Purely decorative — gating itself is enforced where the mode renders.
 */
export const ProBadge: React.FC<{ className?: string }> = ({ className = '' }) => (
  <span
    className={`inline-flex items-center gap-0.5 text-[9px] font-bold uppercase tracking-wide text-amber-300 bg-amber-400/15 border border-amber-400/30 rounded-full px-1.5 py-0.5 leading-none ${className}`}
    title="Pro feature"
  >
    <svg className="w-2.5 h-2.5" fill="currentColor" viewBox="0 0 20 20" aria-hidden="true">
      <path fillRule="evenodd" d="M5 9V7a5 5 0 0110 0v2a2 2 0 012 2v5a2 2 0 01-2 2H5a2 2 0 01-2-2v-5a2 2 0 012-2zm8-2v2H7V7a3 3 0 016 0z" clipRule="evenodd" />
    </svg>
    Pro
  </span>
);
